import React from 'react';
import { Checkbox } from '../dashboard-form';

const FieldCheckboxes = ({fieldsByCategory, onChange, map}) => {
  return <>
    {
      Object.keys(fieldsByCategory).map(cat => (
        <div className="mb-8" key={cat}>
          <h3 className="text-lg font-bold mb-4">{fieldsByCategory[cat].label}</h3>
          <div className="flex flex-wrap">
            {fieldsByCategory[cat].fields.map(field => (
              <div className="w-1/2" key={field.name}>
                <Checkbox
                  className="mr-4 mb-2"
                  label={field.label}
                  onChange={onChange}
                  name={field.name}
                  checked={map[field.name]}
                />
              </div>
            ))}
          </div>
        </div>
      ))
    }
  </>
}

export default FieldCheckboxes
